<div (click)="turnPage($event)" [class.next]="next" [class.previous]="previous" class="page-turner-container">
    <div class="circle">
        <div class="triangle"></div>
    </div>
</div>
